module.exports = "https://cdn.dove.it/_next/static/public/assets/services/promozione_340x200.0944735ee062255b7c4b6edda915a9a1.jpg";